export const NUMBERS_ICONS_PATH = [
  require("@/assets/images/placeholders/home/numbers-icons/1.svg"),
  require("@/assets/images/placeholders/home/numbers-icons/2.svg"),
  require("@/assets/images/placeholders/home/numbers-icons/3.svg"),
  require("@/assets/images/placeholders/home/numbers-icons/4.svg"),
  require("@/assets/images/placeholders/home/numbers-icons/5.svg"),
  require("@/assets/images/placeholders/home/numbers-icons/6.svg"),
  require("@/assets/images/placeholders/home/numbers-icons/7.svg"),
  require("@/assets/images/placeholders/home/numbers-icons/8.svg"),
  require("@/assets/images/placeholders/home/numbers-icons/9.svg"),
  require("@/assets/images/placeholders/home/numbers-icons/10.svg"),
];

export const HIGHLIGHTED_CATEGORIES_ID = [1, 2];
